<template>
  <div class="c-home-update">
    <div
      v-if="
        fields &&
        fields.image &&
        fields.image.value &&
        fields.image.value.src &&
        fields.image.value.src.length > 0
      "
      class="c-home-update__image"
    >
      <sc-image v-if="fields && fields.image" :media="fields.image" />
    </div>
    <div class="c-home-update__content">
      <sc-text
        v-if="fields && fields.heading"
        :field="fields.heading"
        class="c-home-update__heading"
      />
      <sc-text
        v-if="fields && fields.description"
        :field="fields.description"
        class="c-home-update__description"
      />
    </div>
    <div
      class="c-home-update__cta"
      v-if="
        fields &&
        fields.cta &&
        fields.cta.value &&
        fields.cta.value.href &&
        fields.cta.value.href.length > 0
      "
    >
      <sc-link
        v-if="fields && fields.cta"
        :field="fields.cta"
        class="c-cta--secondary"
        :class="fields.cta.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Text, Image, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-Update',
  components: {
    ScText: Text,
    ScImage: Image,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.c-home-update {
  background-color: rgba(0, 133, 190, 0.72);
  border-radius: 0.8rem;
  padding: 4rem 2rem 3rem 2rem;
  margin-top: 2rem;

  @include desktop-up {
    display: flex;
    align-items: center;
    padding: 2.8rem 4rem 2.8rem 5rem;
    margin-top: 0;
  }

  &__image {
    text-align: center;
    margin-bottom: 2rem;

    @include desktop-up {
      text-align: left;
      margin-right: 5rem;
      margin-bottom: 0;
    }
  }

  &__content {
    text-align: center;

    @include desktop-up {
      text-align: left;
    }
  }

  &__heading {
    display: block;
    @include font-styles('Arial', 2rem, 400, normal, 2.6rem, 0, $white);
    margin-bottom: 1rem;

    @include tablet-up {
      margin-bottom: 0.5rem;
    }
  }

  &__description {
    display: block;
    @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $white);
  }

  &__cta {
    margin-top: 4rem;
    text-align: center;

    @include desktop-up {
      margin-top: 0;
      margin-left: 4rem;
      text-align: left;
    }
  }

  .c-cta--secondary {
    color: $white;
    border-left-color: $white;
    margin-bottom: 0;
    white-space: nowrap;

    &:after {
      content: '';
      background-image: url(~@/assets/images/icon-arrow-right-white-mobile.svg);
    }
  }
}
</style>
